var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(!_vm.authUser)?_c('login-form'):_c('div',[_c('app-header'),(_vm.currentQuery)?_c('add-item'):_vm._e(),_c('items-list')],1),(_vm.appMenuOpen)?_c('app-menu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }